import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

interface Alumnus {
  name: string;
  role: string;
  description: string;
  image: string;
}

@Component({
  selector: 'app-our-alumnus',
  templateUrl: './our-alumnus.component.html',
  styleUrls: ['./our-alumnus.component.scss']
})
export class OurAlumnusComponent implements OnInit, AfterViewInit, OnDestroy {
  alumniList: Alumnus[] = [
    {
      name: 'Dr. Anupal Mongia',
      role: 'Assistant Professor (History)',
      description: 'NCA Level-1 Coach and BCCI Match Referee. A dedicated professional who has balanced academic excellence with a stellar career in sports officiating.',
      image: 'assets/img/alumni/alumnus/Anupal_Mongia_img.jpg'
    },
    {
      name: 'Poonam Choudhary',
      role: 'Professional Coach',
      description: 'BCCI Level-1 Professional Strength & Conditioning Coach. Contributing significantly to the fitness and development of aspiring athletes.',
      image: 'assets/img/alumni/alumnus/Anupal_img.jpg'
    },
    {
      name: 'Ms. Neha',
      role: 'Forest Beat Incharge',
      description: 'Serving with dedication in the Haryana Department to protect forest resources and environment.',
      image: 'assets/img/alumni/alumnus/1-Ms. neha...forest beat incharge, haryana department.jpeg'
    },
    {
      name: 'Ms. Kiran',
      role: 'Airwoman, Indian Air Force',
      description: 'Airwoman currently stationed at Assam (Guwahati, Tejpur), serving the nation with honor and pride.',
      image: 'assets/img/alumni/alumnus/2-Ms. Kiran...Airmen , Asaam ( Guwahati, Tejpur).jpeg'
    },
    {
      name: 'Ms. Preeti',
      role: 'CISF, Delhi',
      description: 'Serving in the Central Industrial Security Force (CISF), posted in Delhi.',
      image: 'assets/img/alumni/alumnus/3-Ms. Preeti...CISF,Delhi.jpeg'
    },
    {
      name: 'Ms. Ambika Arora',
      role: 'Principal',
      description: 'A visionary educational leader shaping young minds as a School Principal.',
      image: 'assets/img/alumni/alumnus/4-Ms.Ambika arora...principal.jpeg'
    },
    {
      name: 'Ms. Babita Rani',
      role: 'Principal',
      description: 'Dedicated educator and leader, managing school operations and academic excellence.',
      image: 'assets/img/alumni/alumnus/5-Ms.Babita rani...principal.jpeg'
    },
    {
      name: 'Ms. Jhilmil Bathla',
      role: 'Principal',
      description: 'Inspiring leader in educational administration, championing holistic student development.',
      image: 'assets/img/alumni/alumnus/6-Ms.jhilmil bathla...principal.jpeg'
    },
    {
      name: 'Dr. Priyanka Verma',
      role: 'Principal',
      description: 'Academic leader guiding higher education institutions toward excellence and research development.',
      image: 'assets/img/alumni/alumnus/7.0-Dr. Priyanka Verma....Principal.jpeg'
    },
    {
      name: 'Dr. Yasmee',
      role: 'MDS Pedodontics',
      description: 'Specialist pediatric dentist, ensuring healthy smiles and oral care for children.',
      image: 'assets/img/alumni/alumnus/7.1-Dr. Yasmee....MDS Pedodontics.jpeg'
    },
    {
      name: 'Dr. Gurjot Singla',
      role: 'MDS Orthodontics',
      description: 'Specialist orthodontist, creating beautiful smiles and correcting teeth alignment.',
      image: 'assets/img/alumni/alumnus/7.2-Dr. Gurjot Singla....MDS Orthodontics.jpeg'
    },
    {
      name: 'Ms. Gursimrat Kaur',
      role: 'Director of Physical Education',
      description: 'Promoting physical fitness, training sports candidates, and leading athletic programs.',
      image: 'assets/img/alumni/alumnus/7.3-Ms. Gursimrat Kaur....Director of physical education.jpeg'
    },
    {
      name: 'Ms. Pooja Yadav',
      role: 'Ziladar Patwari, Revenue Dept',
      description: 'Serving as a key administrative official in the state revenue department.',
      image: 'assets/img/alumni/alumnus/8-Ms.pooja yadav....ziladar patwari revenue department.jpeg'
    },
    {
      name: 'Ms. Ramrati Poonia',
      role: 'Patwari, Ganganagar',
      description: 'Handling agricultural land records and revenue administration in Ganganagar.',
      image: 'assets/img/alumni/alumnus/9-Ms. Ramrati Poonia....Patwari, Ganganagar.jpeg'
    },
    {
      name: 'Ms. Amandeep Kaur',
      role: 'Assistant Manager, NICL',
      description: 'Financial and insurance professional at National Insurance Company Limited.',
      image: 'assets/img/alumni/alumnus/9.1-Ms. Amandeep kaur...Assistant Manager at NICL.jpeg'
    },
    {
      name: 'Ms. Gurpreet',
      role: 'Customer Advisor, London',
      description: 'Managing international clients and rendering customer advisory services in London.',
      image: 'assets/img/alumni/alumnus/10-MS. GURPREET...CUSTOMER ADVISOR ,LONDON.jpeg'
    },
    {
      name: 'Ms. Puneet',
      role: 'International Marketing Manager',
      description: 'Formulating global marketing strategies and managing campaigns across international sectors.',
      image: 'assets/img/alumni/alumnus/11-Ms.Puneet...INTERNATIONAL marketing manager.jpeg'
    },
    {
      name: 'Ms. Navjeet Kaur',
      role: 'Income Tax Inspector',
      description: 'Civil servant enforcing tax regulations and serving in the Income Tax Department.',
      image: 'assets/img/alumni/alumnus/12-MS. NAVJEET kaur....income tax inspector.jpeg'
    },
    {
      name: 'Ms. Surbhi',
      role: 'Advocate, Mohali',
      description: 'Practicing law and providing legal representation in Punjab and Haryana courts.',
      image: 'assets/img/alumni/alumnus/13-Ms. surbhi....advocate,mohali.jpeg'
    },
    {
      name: 'Ms. Komal',
      role: 'Judicial Official, Sirsa',
      description: 'Judicial Official serving in the District and Session Court, Sirsa.',
      image: 'assets/img/alumni/alumnus/14-Ms. Komal....Judicial Official in District and Session court,Sirsa.jpeg'
    },
    {
      name: 'Ms. Vandana Dhankar',
      role: 'Advocate, Delhi High Court',
      description: 'Legal practitioner and member of the Delhi High Court Bar Association.',
      image: 'assets/img/alumni/alumnus/15-Ms. Vandana Dhankar....Advocate,Member of Delhi high court bar Association.jpeg'
    },
    {
      name: 'Ms. Parmila',
      role: 'Inspector, Punjab Police',
      description: 'Leading law enforcement teams and ensuring public safety in the state of Punjab.',
      image: 'assets/img/alumni/alumnus/16-Ms. Parmila....Inspector, Punjab Police.jpeg'
    },
    {
      name: 'Ms. Pooja Arora',
      role: 'Director, Upskill Career',
      description: 'Career development mentor, freelancer, and Director guiding professional skill enhancement.',
      image: 'assets/img/alumni/alumnus/17-Ms. Pooja Arora...Director at Upskill Career, Free Lancer.jpeg'
    },
    {
      name: 'Ms. Nirmal Rani',
      role: 'Marketing Manager',
      description: 'Leading marketing campaigns, market research, and brand representation.',
      image: 'assets/img/alumni/alumnus/18-Ms. Nirmal Rani.....Marketing Manager.jpeg'
    },
    {
      name: 'Ms. Rimple Rani',
      role: 'Sub Inspector, Punjab Police',
      description: 'Law enforcement officer serving in the Punjab Police at Ferozepur.',
      image: 'assets/img/alumni/alumnus/19-Ms. Rimple Rani.....Sub inspector,punjab police, ferozepur.jpeg'
    },
    {
      name: 'Ms. Nancy',
      role: 'Assistant Manager, PGB',
      description: 'Financial administrator handling banking transactions and customer services at Punjab Gramin Bank.',
      image: 'assets/img/alumni/alumnus/20-Ms. Nancy....Assistant Manager,Punjab Gramin Bank.jpeg'
    },
    {
      name: 'Ms. Kamalpreet Kaur',
      role: 'Assistant Manager, PGB',
      description: 'Managing operations and rural credit services at Punjab Gramin Bank.',
      image: 'assets/img/alumni/alumnus/20.1-Ms. Kamalpreet Kaur....Assistant manager in Punjab Gramin Bank.jpeg'
    },
    {
      name: 'Ms. Sharda Garg',
      role: 'Manager, PNB',
      description: 'Leading bank operations and branch administration at Punjab National Bank.',
      image: 'assets/img/alumni/alumnus/21-Ms. Sharda garg...Manager at PNB.jpeg'
    },
    {
      name: 'Ms. Anita',
      role: 'Branch Manager, Chandigarh',
      description: 'Heading branch banking operations, customer acquisition, and compliance in Chandigarh.',
      image: 'assets/img/alumni/alumnus/22-Ms. Anita...Branch Manager, Chandigarh.jpeg'
    },
    {
      name: 'Ms. Neha Chabbra',
      role: 'Software Engineer, Deloitte',
      description: 'Developing tech solutions and consulting for global clients at Deloitte, Gurugram.',
      image: 'assets/img/alumni/alumnus/23-Ms. neha chabbra...software engineer Deloitte,gurugram.jpeg'
    },
    {
      name: 'Ms. Mansi',
      role: 'Software Engineer, Alstom',
      description: 'Working on transport automation and software development at Alstom Transportation.',
      image: 'assets/img/alumni/alumnus/24-Ms. mansi..software engineer, alstom transportation.jpeg'
    },
    {
      name: 'Ms. Suruchi',
      role: 'Deputy Manager, WNS',
      description: 'Supervising business process management and client services in Gurugram.',
      image: 'assets/img/alumni/alumnus/25-Ms. Suruchi..Deputy Manager at WNS, Gurugram.jpeg'
    },
    {
      name: 'Ms. Harmeet',
      role: 'Financial Analyst, Wipro',
      description: 'Analyzing financial data and supporting business planning at Wipro.',
      image: 'assets/img/alumni/alumnus/26-Ms.Harmeet....Financial Analyst,WIPRO.jpeg'
    },
    {
      name: 'Ms. Ankita',
      role: 'Delivery Analyst',
      description: 'Delivering business solutions and IT services for corporate clients.',
      image: 'assets/img/alumni/alumnus/27-Ms.Ankita....business & technology delivery analyst.jpeg'
    },
    {
      name: 'Ms. Sugandh',
      role: 'Credit Officer, Indifi',
      description: 'Managing financial risk assessment and merchant lending at Indifi, Gurugram.',
      image: 'assets/img/alumni/alumnus/28-Ms. Sugandh....Credit Officer at indiffi,Gurugram.jpeg'
    },
    {
      name: 'Ms. Tanya',
      role: 'Manager, IndiaMart',
      description: 'Supervising key accounts and business-to-business sales in Gurugram.',
      image: 'assets/img/alumni/alumnus/29-Ms. Tanya...Manager at Indiamart, gurugram.jpeg'
    },
    {
      name: 'Ms. Priyanka',
      role: 'Manager, IndiaMart',
      description: 'Directing B2B sales and e-commerce channel partnerships in New Delhi.',
      image: 'assets/img/alumni/alumnus/30-Ms.Priyanka ....Manager at Indiamart, NEW DELHI.jpeg'
    },
    {
      name: 'Ms. Yishu',
      role: 'Branch Manager, Axis Bank',
      description: 'Managing Axis Bank operations, wealth portfolios, and team performance in Sirsa.',
      image: 'assets/img/alumni/alumnus/31-Ms. Yishu...branch manager at axis bank,Sirsa.jpeg'
    },
    {
      name: 'Ms. Amandeep Singla',
      role: 'Deputy Manager',
      description: 'Supervising banking operations and financial customer services in Punjab.',
      image: 'assets/img/alumni/alumnus/32-Ms. Amandeep singla...Deputy manager, punjab.jpeg'
    },
    {
      name: 'Ms. Himani',
      role: 'Deputy Manager, HDFC Bank',
      description: 'Managing client relations and operational banking processes at HDFC Bank.',
      image: 'assets/img/alumni/alumnus/33-Ms.. himani...management deputy manager, HDFC BANK.jpeg'
    },
    {
      name: 'Ms. Jyoti',
      role: 'Deputy Manager, Axis Bank',
      description: 'Overseeing branch transactions and customer relationship portfolios in Sirsa.',
      image: 'assets/img/alumni/alumnus/34-Ms.Jyoti....Deputy manager at Axis bank,sirsa.jpeg'
    },
    {
      name: 'Ms. Gurpreet',
      role: 'IT Specialist, Chandigarh Police',
      description: 'Managing cyber networks, safety systems, and IT infrastructure for Chandigarh Police.',
      image: 'assets/img/alumni/alumnus/35-Ms.Gurpreet, chandigarh police(IT).jpeg'
    },
    {
      name: 'Ms. Taruna',
      role: 'Postal Assistant, India Post',
      description: 'Handling mail operations, savings account services, and speed-post logs in Sirsa.',
      image: 'assets/img/alumni/alumnus/36-Ms. Taruna.....Postal Assistant,Sirsa.jpeg'
    },
    {
      name: 'Ms. Simran Bumrah',
      role: 'Professional Singer',
      description: 'Vocalist and performer, honored with the PTC Rising Star Award in 2024.',
      image: 'assets/img/alumni/alumnus/37-Ms. Simran Bumrah....Professional singer & Performer, PTC Rising Star Awardee 2024.jpeg'
    }
  ];

  displayedAlumni: Alumnus[] = [];

  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;

  private scrollInterval: any;
  private scrollSpeed = 1; // pixels to scroll each interval step
  private stepTime = 25; // millisecond interval step

  constructor() { }

  ngOnInit(): void {
    // Clone the first 8 cards and append to the end for seamless infinite scroll
    const cloneCount = Math.min(8, this.alumniList.length);
    this.displayedAlumni = [...this.alumniList, ...this.alumniList.slice(0, cloneCount)];
  }

  ngAfterViewInit() {
    this.startAutoScroll();
  }

  ngOnDestroy() {
    this.stopAutoScroll();
  }

  startAutoScroll() {
    this.stopAutoScroll();
    this.scrollInterval = setInterval(() => {
      if (this.scrollContainer && this.scrollContainer.nativeElement) {
        const el = this.scrollContainer.nativeElement;
        el.scrollLeft += this.scrollSpeed;

        const originalCount = this.alumniList.length;
        if (el.children && el.children.length > originalCount) {
          const resetTarget = (el.children[originalCount] as HTMLElement).offsetLeft;
          if (el.scrollLeft >= resetTarget) {
            el.scrollLeft = 0;
          }
        }
      }
    }, this.stepTime);
  }

  stopAutoScroll() {
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
    }
  }
}
